// What a picked file IS, from its type and name, and why one is refused. Pure.
import { IMAGE_TYPES, PDF_TYPE, MAX_FILE_BYTES, type HandoutKind, type Refused } from './types';
import { formatBytes, sizeLabel } from './quota';

export function kindOf(file: { type: string; name: string }): HandoutKind | null {
  const type = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  if ((IMAGE_TYPES as readonly string[]).includes(type) || /\.(png|jpe?g|webp|gif)$/.test(name)) return 'image';
  if (type === PDF_TYPE || name.endsWith('.pdf')) return 'pdf';
  return null;
}

/** A refusal whose sentence is `"name" is <reason>.` */
const refused = (name: string, reason: string): Refused => ({ name, reason, sentence: `"${name}" is ${reason}.` });

/** Null when the file is an image or a PDF, else why not. */
export function kindRefusal(file: { type: string; name: string }): Refused | null {
  return kindOf(file) ? null : refused(file.name, 'not an image or a PDF');
}

/** Null when `bytes` is within the per-file limit, else why not. */
export function sizeRefusal(name: string, bytes: number): Refused | null {
  if (bytes <= MAX_FILE_BYTES) return null;
  return refused(name, `${formatBytes(bytes)} - the limit is ${sizeLabel(MAX_FILE_BYTES)} per file`);
}
